// its use folder name
const moduleOrder = [
  "dashboard",
  "activities",
  "print",
  "finance",
  "settings",
  "master",
];
export default moduleOrder;



// WEBPACK FOOTER //
// ./src/modules/_order.js